/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureResourceCoverage {
    getFixupPrototypeFunction() { return TagPostureResourceCoverage.fixupPrototype; }

    static newInstance(model: Partial<TagPostureResourceCoverage>): TagPostureResourceCoverage {
        let obj = Object.assign(new TagPostureResourceCoverage(), model);
        TagPostureResourceCoverage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureResourceCoverage>): TagPostureResourceCoverage {
        if (!model) return null;
        return TagPostureResourceCoverage.newInstance(<TagPostureResourceCoverage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureResourceCoverage) {
        if (!obj) return;

        models.TagPostureResourceCoverage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureResourceCoverage): boolean {
        Object.setPrototypeOf(obj, TagPostureResourceCoverage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_count === undefined) {
            this.resource_count = 0;
        }
        if (this.valid_resource_count === undefined) {
            this.valid_resource_count = 0;
        }
        if (this.tag_counts) {
            models.TagPostureSummaryCount.fixupPrototype(this.tag_counts);
        }
    }

    /**
     * Total number of resources
     */
    resource_count: number;

    /**
     * Number of resources with 100% coverage
     */
    valid_resource_count: number;

    /**
     * Count of tags for all resources
     */
    tag_counts: models.TagPostureSummaryCount;

    /**
     * List of missing tag keys
     */
    missing_tag_keys: Array<string>;

    /**
     * Map of invalid tag values
     */
    invalid_tag_values: { [key: string]: string; };

}
